export default __webpack_public_path__ + "static/damixa-brand--mobile@1x-3bfe0170a34fd4b9a88322d2d0679cae.webp";